import AmountWithCurrency from './AmountWithCurrency';

export default AmountWithCurrency;